import { render, staticRenderFns } from "./CoozzySearchSelect.vue?vue&type=template&id=44e1a3c0&scoped=true"
import script from "./CoozzySearchSelect.vue?vue&type=script&lang=js"
export * from "./CoozzySearchSelect.vue?vue&type=script&lang=js"
import style0 from "./CoozzySearchSelect.vue?vue&type=style&index=0&id=44e1a3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1a3c0",
  null
  
)

export default component.exports